import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService, EnvironmentUtilService } from '../../shared';

@Injectable({
  providedIn: 'root',
})
export class ActivityLogApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/activity-logs`, {
      params,
    });
  }
}
